/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReadOnlyWhiteLabel,
    ReadOnlyWhiteLabelFromJSON,
    ReadOnlyWhiteLabelFromJSONTyped,
    ReadOnlyWhiteLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse20050
 */
export interface InlineResponse20050 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20050
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20050
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20050
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<ReadOnlyWhiteLabel>}
     * @memberof InlineResponse20050
     */
    results: Array<ReadOnlyWhiteLabel>;
}

export function InlineResponse20050FromJSON(json: any): InlineResponse20050 {
    return InlineResponse20050FromJSONTyped(json, false);
}

export function InlineResponse20050FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20050 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(ReadOnlyWhiteLabelFromJSON)),
    };
}

export function InlineResponse20050ToJSON(value?: InlineResponse20050 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': ((value.results as Array<any>).map(ReadOnlyWhiteLabelToJSON)),
    };
}


